/* eslint-disable no-undef, no-underscore-dangle */
import {
  getNotifications,
  hideNotification,
} from '@/services/notifications';

import { POLL_INTERVAL } from '@/config';

import {
  SET_NOTIFICATIONS,
  REMOVE_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  CANCEL_POLL_NOTIFICATIONS,
  START_POLL_NOTIFICATIONS,
  LOADING,
  LOADING_SUCCESS,
} from './mutation-types';

const business = {
  state: {
    showNotifications: false,
    list: [],
    pollTimeout: null,
  },
  mutations: {
    [SET_NOTIFICATIONS](state, notifications) {
      state.list = notifications.reverse();
    },
    [REMOVE_NOTIFICATION](state, id) {
      state.list = state.list.filter(n => n._id !== id);
    },
    [CLEAR_NOTIFICATIONS](state) {
      state.list = [];
    },
    [CANCEL_POLL_NOTIFICATIONS](state) {
      clearTimeout(state.pollTimeout);
      state.pollTimeout = null;
    },
    [START_POLL_NOTIFICATIONS](state, timeout) {
      state.pollTimeout = timeout;
    },
  },
  actions: {
    getNotifications({ commit }) {
      return new Promise((resolve, reject) =>
        getNotifications()
          .then((res) => {
            const { data } = res;
            if (data && data.pending_appointments) {
              commit(SET_NOTIFICATIONS, data.pending_appointments);
            } else {
              reject(new Error('Could not fetch notifications'));
            }
          }));
    },
    pollNotifications({ commit, dispatch }) {
      return getNotifications()
        .then((res) => {
          const { data } = res;
          if (data && data.pending_appointments) {
            commit(SET_NOTIFICATIONS, data.pending_appointments);
          }
          const timeout = setTimeout(() => {
            dispatch('pollNotifications');
          }, POLL_INTERVAL);
          commit(START_POLL_NOTIFICATIONS, timeout);
        })
        .catch(({ response }) => {
          if (!response) {
            return Promise.reject(new Error('Could not connect to server.'));
          }
          const { data } = response;
          if (data.error) {
            return Promise.reject(data.error);
          }
          return Promise.reject(new Error('Could not poll notifications.'));
        });
    },
    cancelPollNotifications({ commit }) {
      commit(CANCEL_POLL_NOTIFICATIONS);
    },
    clearNotifications({ commit, dispatch }) {
      commit(CLEAR_NOTIFICATIONS);
      dispatch('cancelPollNotifications');
    },
    hideNotification({ commit }, notificationId) {
      commit(LOADING);
      return new Promise((resolve, reject) =>
        hideNotification(notificationId)
          .then((res) => {
            commit(LOADING_SUCCESS);
            const { data } = res;
            if (!data) {
              const err = new Error('Notification not found');
              reject(err);
            } else {
              commit(REMOVE_NOTIFICATION, notificationId);
              resolve(notificationId);
            }
          }));
    },
  },
};

export default business;



// WEBPACK FOOTER //
// ./src/store/notifications.js